import { ACTIVE } from "components/constants";
import { useState } from "react";
import { toCurrency } from "utils/helpers";
import { PENDING } from "utils/helpers/constants";
import StatusPill from "utils/pills/StatusPill/StatusPill";
import Table from "utils/Table/Table";
import BankingWalletFilters from "../../common/BankingWalletFilters";
import SubscriptionModal from "../../common/modals/SubscriptionModal";
import {
	CardsTableHeadings,
	bankingWalletsTableData,
	bankingWalletsFiltersDefaultValues,
} from "../../helpers/data";

const SubscriptionTable = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [currentRowValues, setCurrentRowValues] = useState({});
	const [formValues, setFormValues] = useState({
		...bankingWalletsFiltersDefaultValues,
	});

	const toggleModal = () => setIsOpen((prev) => !prev);

	const handleChange = ({ target: { name, value } }) =>
		handleSelect(name, value);

	const handleSelect = (name, value) => {
		console.log({ name, value });
		setFormValues((prev) => ({
			...prev,
			[name]: value,
		}));
	};
	const handleSubmit = () =>
		setFormValues({ ...bankingWalletsFiltersDefaultValues });

	const getWalletData = () =>
		bankingWalletsTableData?.map((transaction) => ({
			walletId: transaction?.walletId,
			name: "Golden Entry Access Pan",
			cardType: "Recurring",
			interval: `Monthly`,
			amount: `₦ ${toCurrency(transaction?.balance)}`,
			charges: `₦ ${toCurrency(300)}`,
			status: (
				<StatusPill
					status="Active"
					success={ACTIVE}
					warning={PENDING}
				/>
			),
			createdAt: transaction?.createdAt,
		}));

	const handleRowClick = (_, rowValues) => {
		const transactionData = bankingWalletsTableData?.find(
			(transaction) => transaction?.reference === rowValues?.transactionID
		);
		setCurrentRowValues({
			...rowValues,
			...transactionData,
		});
		toggleModal();
	};
	return (
		<>
			<BankingWalletFilters
				formValues={formValues}
				handleChange={handleChange}
				handleSubmit={handleSubmit}
				handleSelect={handleSelect}
			/>
			<Table
				data={getWalletData()}
				headings={CardsTableHeadings}
				rowClick={handleRowClick}
			/>
			{isOpen && (
				<SubscriptionModal
					toggle={toggleModal}
					payment={currentRowValues}
					IDTabName={`Subscription Information`}
				/>
			)}
		</>
	);
};

export default SubscriptionTable;
